{
  "common": {
    "loading": "Loading...",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "back": "Back",
    "goBack": "Go Back",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "info": "Info",
    "welcome": "Welcome",
    "capabilities": "Capabilities",
    "accessDenied": "Access Denied",
    "permissionDenied": "You do not have permission to create or edit drones.",
    "profile": "Profile",
    "lastLogin": "Last Login",
    "accountActivity": "Account Activity",
    "contactAdmin": "Contact your administrator for account access",
    "time": "Time",
    "totalTime": "Total time",
    "notSet": "Not set",
    "unknown": "Unknown"
  },
  "nav": {
    "home": "Home",
    "flights": "Flights",
    "drones": "Drones",
    "users": "Users",
    "procedures": "Procedures & Checklists",
    "tasks": "Tasks",
    "info": "Info & Contact",
    "auditLogs": "Audit Logs"
  },
  "flights": {
    "title": "Flights",
    "newFlight": "New Flight",
    "logbook": "Logbook",
    "flightDetails": "Flight Details",
    "addFlight": "Add Flight",
    "editFlight": "Edit Flight",
    "add": "Add Flight",
    "edit": "Edit Flight",
    "delete": "Delete Flight",
    "category": "Category",
    "operation": "Operation",
    "activity": "Activity",
    "conditions": "Conditions",
    "pilot": "Pilot",
    "operator": "Operator",
    "noFlightsFound": "No flights found",
    "tapAddFlightToStart": "Tap \"Add Flight\" to create your first flight log",
    "errors": {
      "fetchFailed": "Failed to fetch flights"
    }
  },
  "drones": {
    "title": "Drones",
    "registry": "Drone Registry",
    "add": "Add Drone",
    "edit": "Edit Drone",
    "addDrone": "Add Drone",
    "editDrone": "Edit Drone",
    "droneDetails": "Drone Details",
    "details": "Drone Details",
    "viewDetails": "View Details",
    "deleted": "DELETED",
    "restore": "Restore",
    "deleteTitle": "Delete Drone",
    "deleteConfirmation": "Are you sure you want to delete \"{{name}}\"? This action can be undone by an admin.",
    "deleteSuccess": "Drone deleted successfully",
    "restoreTitle": "Restore Drone",
    "restoreConfirmation": "Are you sure you want to restore \"{{name}}\"?",
    "restoreSuccess": "Drone restored successfully",
    "callSign": "Call Sign",
    "registration": "Registration",
    "location": "Location",
    "flightTime": "Flight Time",
    "insurance": "Insurance",
    "maxSpeed": "Max Speed",
    "range": "Range",
    "weight": "Weight",
    "maxWeight": "Max",
    "manufactured": "Manufactured",
    "commissioned": "Commissioned",
    "noDronesFound": "No drones found",
    "addFirstDrone": "Add your first drone using the 'Add Drone' button above",
    "noDronesAvailable": "No drones are available at the moment",
    "errors": {
      "fetchFailed": "Failed to fetch drones. Please check your Firebase configuration and try again.",
      "deleteFailed": "Failed to delete drone",
      "restoreFailed": "Failed to restore drone",
      "notFoundOrNoPermission": "Drone not found or you do not have permission to view it"
    }
  },
  "missions": {
    "title": "Missions",
    "newMission": "New Mission",
    "details": "Mission Details"
  },
  "auth": {
    "signIn": "Sign In",
    "signOut": "Sign Out",
    "email": "Email",
    "password": "Password",
    "login": "Login",
    "loginWithGoogle": "Sign in with Google"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "theme": "Theme",
    "profile": "Profile"
  },
  "languages": {
    "pl": "Polski",
    "en": "English"
  },
  "users": {
    "title": "Users",
    "management": "User Management",
    "manageRolesPermissions": "Manage user roles and permissions",
    "accessDenied": "Access Denied",
    "accessDeniedMessage": "Only administrators and managers can access user management.",
    "updateRole": "Update User Role",
    "selectNewRole": "Select new role:",
    "roleUpdated": "User role updated to {{role}}",
    "viewDetails": "View Details",
    "role": "Role",
    "errors": {
      "fetchFailed": "Failed to fetch users",
      "roleUpdateFailed": "Failed to update user role"
    }
  },
  "user": {
    "details": "User Details",
    "role": "Role",
    "admin": "Admin",
    "manager": "Manager",
    "user": "User",
    "email": "Email",
    "firstName": "First Name",
    "lastName": "Last Name",
    "roles": {
      "admin": "ADMINISTRATOR",
      "manager": "MANAGER",
      "user": "USER"
    }
  },
  "userForm": {
    "editTitle": "Edit User",
    "createTitle": "Create User",
    "loading": "Loading user data...",
    "basicInfo": "Basic Information",
    "operatorInfo": "Operator Information",
    "pilotInfo": "Pilot Information",
    "licenseInfo": "License Information",
    "qualifications": "Qualifications / Authorizations",
    "qualificationsSubtitle": "Select applicable qualifications (at least one required):",
    "email": "Email",
    "emailPlaceholder": "Enter email address",
    "firstName": "First Name",
    "firstNamePlaceholder": "Enter first name",
    "surname": "Surname",
    "surnamePlaceholder": "Enter surname",
    "phone": "Phone",
    "phonePlaceholder": "Enter phone number",
    "address": "Residential Address",
    "addressPlaceholder": "Enter residential address",
    "language": "Language",
    "languagePlaceholder": "Choose language",
    "role": "Role",
    "rolePlaceholder": "Choose role",
    "operatorNumber": "Operator Number",
    "operatorNumberPlaceholder": "Enter operator number",
    "operatorValidityDate": "Operator Validity Date",
    "pilotNumber": "Pilot Number",
    "pilotNumberPlaceholder": "Enter pilot number",
    "pilotValidityDate": "Pilot Validity Date",
    "licenseConversionNumber": "License Conversion Number or Administrative Decision Number",
    "licenseConversionPlaceholder": "Enter license conversion number",
    "insurance": "Insurance Date",
    "insuranceDate": "Insurance Date",
    "insuranceDatePlaceholder": "Enter insurance validity date",
    "updateButton": "Update User",
    "createButton": "Create User",
    "updateSuccess": "User updated successfully",
    "createSuccess": "User created successfully",
    "saveError": "Failed to save user data",
    "success": "Success",
    "userUpdated": "User info updated successfully",
    "validation": {
      "title": "Validation Error",
      "message": "Please correct the highlighted fields and try again.",
      "emailRequired": "Email is required",
      "firstNameRequired": "First name is required",
      "surnameRequired": "Surname is required",
      "operatorOrPilotRequired": "Either Operator Number or Pilot Number is required",
      "qualificationsRequired": "At least one qualification/authorization must be selected",
      "emailInvalid": "Please enter a valid email address.",
      "firstnameRequired": "First name is required.",
      "roleRequired": "Role is required.",
      "languageRequired": "Language is required.",
      "languageInvalid": "Selected language is not valid.",
      "phoneInvalid": "Please enter a valid phone number.",
      "dateInvalid": "Please use the YYYY-MM-DD date format.",
      "qualificationsInvalid": "Selected qualification is not valid."
    }
  },
  "userDetails": {
    "title": "User Details",
    "basicInfo": "Basic Information",
    "contactInfo": "Contact Information",
    "operatorInfo": "Operator Information",
    "pilotInfo": "Pilot Information",
    "licenseInfo": "License Information",
    "qualifications": "Qualifications",
    "accountInfo": "Account Information",
    "editButton": "Edit Profile",
    "noPhone": "Not provided",
    "noAddress": "Not provided",
    "noData": "No data",
    "notFound": "User not found",
    "loadError": "Failed to load user details"
  },
  "flightDetails": {
    "title": "Flight Details",
    "basicInfo": "Basic Information",
    "operationalInfo": "Operational Information",
    "auditInfo": "Audit Information",
    "editButton": "Edit Flight",
    "deleteButton": "Delete Flight",
    "category": "Category",
    "operation": "Operation",
    "activity": "Activity",
    "conditions": "Conditions",
    "drone": "Drone",
    "pilot": "Pilot",
    "operator": "Operator",
    "duration": "Duration",
    "location": "Location",
    "coordinates": "Coordinates",
    "viewOnMap": "View on Google Maps",
    "date": "Date",
    "createdBy": "Created by",
    "updatedBy": "Updated by",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "deleteConfirmTitle": "Delete Flight",
    "deleteConfirmMessage": "Are you sure you want to delete this flight? This action cannot be undone.",
    "deleteSuccess": "Flight deleted successfully",
    "deleteError": "Failed to delete flight",
    "notFound": "Flight not found or you do not have permission to view it",
    "loadError": "Failed to fetch flight details"
  },
  "flightForm": {
    "editTitle": "Edit Flight",
    "createTitle": "New Flight",
    "basicInfo": "Basic Information",
    "operationalInfo": "Operational Information",
    "category": "Category",
    "categoryPlaceholder": "Select category",
    "operation": "Operation",
    "operationPlaceholder": "Select operation",
    "activity": "Activity",
    "activityPlaceholder": "Select activity",
    "conditions": "Conditions",
    "conditionsPlaceholder": "Weather and flight conditions (optional)",
    "additionalInfo": "Additional Info",
    "additionalInfoPlaceholder": "Enter any additional information about the flight (optional)",
    "drone": "Drone",
    "dronePlaceholder": "Select a drone",
    "otherDrone": "Other (manual entry)",
    "customDroneName": "Custom Drone Name",
    "customDroneNamePlaceholder": "Enter drone name",
    "operator": "Operator",
    "operatorPlaceholder": "Select operator",
    "duration": "Duration (minutes)",
    "durationPlaceholder": "Enter duration",
    "location": "Location",
    "locationPlaceholder": "Enter flight location",
    "coordinates": "Coordinates",
    "coordinatesPlaceholder": "Enter coordinates (lat, lng)",
    "date": "Date",
    "datePlaceholder": "YYYY-MM-DD",
    "startDate": "Start Date",
    "startTime": "Start Time",
    "startTimePlaceholder": "HH:mm (e.g. 14:30)",
    "endDate": "End Date",
    "endTime": "End Time",
    "endTimePlaceholder": "HH:mm (e.g. 16:30)",
    "updateButton": "Update Flight",
    "createButton": "Create Flight",
    "updateSuccess": "Flight updated successfully",
    "createSuccess": "Flight created successfully",
    "saveError": "Failed to save flight",
    "notFound": "Flight not found",
    "loadError": "Failed to fetch flight data",
    "validation": {
      "title": "Validation Error",
      "message": "Please fill in all required fields.",
      "categoryRequired": "Category is required",
      "operationRequired": "Operation is required",
      "activityRequired": "Activity is required",
      "conditionsRequired": "Conditions are required",
      "droneRequired": "Drone is required",
      "operatorRequired": "Operator is required",
      "durationRequired": "Duration is required",
      "locationRequired": "Location is required",
      "coordinatesRequired": "Coordinates are required",
      "dateRequired": "Date is required",
      "droneIdRequired": "Drone is required",
      "startDateRequired": "Start date is required",
      "startTimeRequired": "Start time is required",
      "endDateRequired": "End date is required",
      "endTimeRequired": "End time is required",
      "flightCategoryRequired": "Flight category is required",
      "operationTypeRequired": "Operation type is required",
      "activityTypeRequired": "Activity type is required",
      "noDronesAvailable": "No drones available. Please add drones first.",
      "selectValidDrone": "Please select a valid drone",
      "customDroneNameRequired": "Custom drone name is required",
      "dateFormat": "Date must be in YYYY-MM-DD format",
      "startDateFormat": "Start date must be in YYYY-MM-DD format",
      "endDateFormat": "End date must be in YYYY-MM-DD format",
      "startTimeFormat": "Start time must be in HH:mm format",
      "endTimeFormat": "End time must be in HH:mm format",
      "invalidDateTime": "Invalid date/time format",
      "endAfterStart": "End time must be after start time",
      "maxDuration24Hours": "Flight duration cannot exceed 24 hours"
    }
  },
  "droneDetails": {
    "title": "Drone Details",
    "basicInfo": "Basic Information",
    "technicalInfo": "Technical Information",
    "operationalInfo": "Operational Information",
    "batteryInfo": "Battery Information",
    "manufacturingInfo": "Manufacturing Information",
    "documentation": "Documentation",
    "images": "Images",
    "auditInfo": "Audit Information",
    "editButton": "Edit Drone",
    "deleteButton": "Delete Drone",
    "restoreButton": "Restore Drone",
    "name": "Name",
    "model": "Model",
    "serialNumber": "Serial Number",
    "callSign": "Call Sign",
    "registration": "Registration",
    "equipmentRegistration": "Equipment Registration",
    "manufacturer": "Manufacturer",
    "weight": "Weight",
    "maxWeight": "Max Takeoff Weight",
    "maxSpeed": "Max Speed",
    "range": "Range",
    "flightTime": "Total Flight Time",
    "operatingTime": "Operating Time",
    "location": "Location",
    "insurance": "Insurance",
    "manufactured": "Year of Manufacture",
    "commissioned": "Year of Commissioning",
    "status": "Status",
    "deleted": "DELETED",
    "active": "ACTIVE",
    "dimensions": "Dimensions",
    "batteryType": "Type",
    "batteryCapacity": "Capacity",
    "batteryVoltage": "Voltage",
    "openManual": "Open User Manual",
    "deletedAt": "Deleted",
    "deleteConfirmTitle": "Delete Drone",
    "deleteConfirmMessage": "Are you sure you want to delete \"{{name}}\"? This action can be undone by an admin.",
    "restoreConfirmTitle": "Restore Drone",
    "restoreConfirmMessage": "Are you sure you want to restore \"{{name}}\"?",
    "deleteSuccess": "Drone deleted successfully",
    "restoreSuccess": "Drone restored successfully",
    "deleteError": "Failed to delete drone",
    "restoreError": "Failed to restore drone",
    "manualError": "Failed to open user manual",
    "notFound": "Drone not found",
    "loadError": "Failed to fetch drone details"
  },
  "droneForm": {
    "editTitle": "Edit Drone",
    "createTitle": "New Drone",
    "basicInfo": "Basic Information",
    "technicalInfo": "Technical Information",
    "operationalInfo": "Operational Information",
    "namePlaceholder": "Enter drone name",
    "model": "Model",
    "modelPlaceholder": "Enter drone model",
    "serialNumber": "Serial Number",
    "serialNumberPlaceholder": "Enter serial number",
    "callSign": "Call Sign",
    "callSignPlaceholder": "Enter call sign",
    "inventoryCode": "Inventory Code",
    "inventoryCodePlaceholder": "Enter inventory code",
    "registration": "Registration",
    "registrationPlaceholder": "Enter registration number",
    "manufacturer": "Manufacturer",
    "manufacturerPlaceholder": "Enter manufacturer name",
    "weight": "Weight (g)",
    "weightPlaceholder": "Enter weight",
    "maxWeight": "Max Weight (g)",
    "maxWeightPlaceholder": "Enter maximum weight",
    "maxSpeed": "Max Speed (km/h)",
    "maxSpeedPlaceholder": "Enter maximum speed",
    "range": "Range (m)",
    "rangePlaceholder": "Enter range",
    "flightTime": "Flight Time (min)",
    "flightTimePlaceholder": "Enter flight time",
    "location": "Location",
    "locationPlaceholder": "Enter location",
    "insurance": "Insurance Date",
    "insurancePlaceholder": "YYYY-MM-DD",
    "manufactured": "Manufactured Date",
    "manufacturedPlaceholder": "YYYY-MM-DD",
    "commissioned": "Commissioned Date",
    "commissionedPlaceholder": "YYYY-MM-DD",
    "updateButton": "Update Drone",
    "createButton": "Create Drone",
    "updateSuccess": "Drone updated successfully",
    "createSuccess": "Drone created successfully",
    "saveError": "Failed to save drone",
    "validation": {
      "title": "Validation Error",
      "message": "Please fill in all required fields.",
      "nameRequired": "Name is required",
      "modelRequired": "Model is required",
      "serialNumberRequired": "Serial number is required",
      "callSignRequired": "Call sign is required",
      "inventoryCodeRequired": "Inventory code is required",
      "registrationRequired": "Registration is required",
      "manufacturerRequired": "Manufacturer is required"
    },
    "title": "Drones",
    "addTitle": "Add New Drone",
    "loading": "Loading drone data...",
    "flightInfo": "Flight Information",
    "physicalSpecs": "Physical Specifications",
    "batteryInfo": "Battery Information",
    "manufacturingInfo": "Manufacturing Information",
    "documentation": "Documentation",
    "name": "Drone Name",
    "nameRequired": "Drone name is required",
    "callSignRequired": "Call sign is required",
    "registrationNumber": "Registration Number",
    "registrationRequired": "Registration number is required",
    "equipmentRegistration": "Equipment Registration Number",
    "equipmentRegistrationPlaceholder": "Enter equipment registration number",
    "totalFlightTime": "Total Flight Time (minutes)",
    "operatingTime": "Operating Time (minutes)",
    "maxTakeoffWeight": "Max Takeoff Weight (grams)",
    "length": "Length (mm)",
    "width": "Width (mm)",
    "height": "Height (mm)",
    "batteryType": "Battery Type",
    "batteryTypePlaceholder": "Enter battery type",
    "capacity": "Capacity (mAh)",
    "voltage": "Voltage (V)",
    "yearOfManufacture": "Year of Manufacture",
    "yearOfCommissioning": "Year of Commissioning",
    "userManual": "User Manual URL (optional)",
    "userManualPlaceholder": "https://...",
    "additionalInfo": "Additional Info",
    "additionalInfoPlaceholder": "Enter any additional information about the drone (optional)",
    "images": "Images",
    "cancel": "Cancel",
    "updateDrone": "Update Drone",
    "createDrone": "Create Drone",
    "validationError": "Validation Error",
    "success": "Success",
    "error": "Error",
    "droneNotFound": "Drone not found",
    "cannotEditDeleted": "Cannot edit deleted drone",
    "failedToLoad": "Failed to load drone data",
    "droneUpdated": "Drone updated successfully",
    "droneCreated": "Drone created successfully",
    "failedToUpdate": "Failed to update drone",
    "failedToCreate": "Failed to create drone",
    "shareable": "Shareable Drone",
    "shareableDescription": "Allow users to claim and use this drone"
  },
  "droneClaims": {
    "claimStatus": "Claim Status",
    "viewHistory": "View History",
    "ownedBy": "Owned by: {{owner}}",
    "claimedSince": "Claimed on {{date}} at {{time}} ({{duration}})",
    "available": "Available for claiming",
    "claimDrone": "Claim this drone",
    "releaseClaim": "Release claim",
    "forceRelease": "Force release",
    "adminOverride": "Admin Override",
    "adminOverrideNotImplemented": "Admin override functionality will be implemented soon",
    "droneClaimedSuccess": "Drone claimed successfully",
    "droneReleasedSuccess": "Drone claim released successfully",
    "failedToClaim": "Failed to claim drone",
    "failedToRelease": "Failed to release claim",
    "failedToLoadHistory": "Failed to load claim history",
    "claimHistory": "Claim History",
    "noClaimHistory": "No claim history available",
    "active": "Active",
    "completed": "Completed",
    "ongoing": "Ongoing",
    "claimPeriod": "{{start}} {{startTime}} - {{end}} {{endTime}} ({{duration}})",
    "userSearchError": "Failed to search users",
    "overridingFor": "Overriding claim for",
    "currentOwner": "Current owner",
    "overrideOptions": "Override Options",
    "endClaimOnly": "End current claim only",
    "assignToNewUser": "Assign to New User",
    "searchUsers": "Search users by name or email...",
    "selectUserFirst": "Please select a user first",
    "claimEndedSuccess": "Claim ended successfully",
    "overrideFailed": "Failed to override claim",
    "droneAssignedSuccess": "Drone assigned to {{user}} successfully",
    "assignToDrone": "Assign to this drone",
    "confirmClaim": "Confirm Claim",
    "confirmClaimMessage": "Are you sure you want to claim {{droneName}}?",
    "confirmRelease": "Confirm Release",
    "confirmReleaseMessage": "Are you sure you want to release the claim on {{droneName}}?",
    "assignDrone": "Assign Drone"
  },
  "imageForm": {
    "permissionRequired": "Permission Required",
    "permissionDenied": "Camera and photo library permissions are required to add images.",
    "error": "Error",
    "failedToPickImage": "Failed to pick image. Please try again.",
    "confirmDelete": "Delete Image",
    "confirmDeleteMessage": "Are you sure you want to delete this image?",
    "addFirstImage": "Add Image",
    "addImage": "Add Another Image",
    "imageCount": "{{count}} of {{max}} images"
  },
  "dashboard": {
    "title": "GOPR UAV Ops Manager",
    "welcome": "Welcome",
    "capabilitiesTitle": "Capabilities",
    "accountActivity": "Account Activity",
    "lastLogin": "Last Login",
    "profileData": "My Profile Data",
    "basicInformation": "Basic Information",
    "operatorInfo": "Operator Information",
    "pilotInfo": "Pilot Information",
    "additionalInfo": "Additional Information",
    "qualifications": "Qualifications / Authorizations",
    "profileManagement": "Profile Management",
    "editMyData": "Edit My Data",
    "menuInfo": "Use the menu (☰) to navigate between different sections of the app.",
    "roleInfo": "Additional role-based functionality is available based on your {{role}} permissions.",
    "email": "Email",
    "firstName": "First Name",
    "surname": "Surname",
    "phone": "Phone",
    "residentialAddress": "Residential Address",
    "operatorNumber": "Operator Number",
    "operatorValidityDate": "Operator Validity Date",
    "pilotNumber": "Pilot Number",
    "pilotValidityDate": "Pilot Validity Date",
    "licenseConversion": "License Conversion Number",
    "insuranceDate": "Insurance Date",
    "noQualifications": "No qualifications set",
    "notSet": "Not set",
    "capabilities": {
      "admin": [
        "Full system access",
        "User management",
        "All operations",
        "System configuration"
      ],
      "manager": [
        "Operation management",
        "Team oversight",
        "Reports viewing",
        "Limited user management"
      ],
      "user": [
        "Basic operations",
        "View assigned tasks",
        "Update status"
      ],
      "default": [
        "Limited access"
      ]
    },
    "navigation": {
      "flights": "Flight Management",
      "drones": "Drone Registry",
      "procedures": "Procedures & Checklists",
      "profile": "My Profile",
      "users": "User Management",
      "tasks": "Tasks",
      "logs": "Audit Logs"
    }
  },
  "procedures": {
    "title": "Procedure/Checklist",
    "allProcedures": "All Procedures",
    "viewAll": "View All",
    "loading": "Loading procedure/checklist...",
    "notFound": "Procedure/Checklist Not Found",
    "notFoundDescription": "The requested procedure or checklist could not be found.",
    "goBack": "Go Back",
    "edit": "Edit",
    "deleted": "DELETED",
    "created": "Created",
    "updated": "Updated",
    "by": "by",
    "items": "item",
    "itemsPlural": "items",
    "openLink": "Open Link",
    "openFile": "Open File",
    "deleteTitle": "Delete Procedure/Checklist",
    "deleteConfirmation": "Are you sure you want to delete \"{{title}}\"? This action can be undone by an admin.",
    "deleteSuccess": "Procedure/checklist deleted successfully",
    "deleteError": "Failed to delete procedure/checklist",
    "restoreTitle": "Restore Procedure/Checklist",
    "restoreConfirmation": "Are you sure you want to restore \"{{title}}\"?",
    "restoreSuccess": "Procedure/checklist restored successfully",
    "restoreError": "Failed to restore procedure/checklist",
    "addNew": "Add New",
    "itemSingle": "item",
    "itemPlural": "items",
    "createdOn": "Created {{date}}",
    "editProcedure": "Edit procedure/checklist",
    "searchPlaceholder": "Search procedures...",
    "search": {
      "noResults": "No Procedures Found",
      "noResultsDescription": "No procedures match \"{{query}}\". Try adjusting your search terms.",
      "clearSearch": "Clear Search"
    },
    "categories": {
      "title": "Procedures",
      "titleHeader": "Procedure categories"
    },
    "empty": {
      "title": "No Procedures or Checklists",
      "descriptionCanCreate": "Create your first procedure or checklist to get started.",
      "descriptionCannotCreate": "No procedures or checklists have been created yet."
    },
    "delete": {
      "button": "Delete",
      "title": "Delete Procedure/Checklist",
      "confirmMessage": "Are you sure you want to delete \"{{title}}\"? This action can be undone by an admin.",
      "successMessage": "Procedure/checklist deleted successfully",
      "errorMessage": "Failed to delete procedure/checklist"
    },
    "restore": {
      "button": "Restore",
      "successMessage": "Procedure/checklist restored successfully",
      "errorMessage": "Failed to restore procedure/checklist"
    },
    "errors": {
      "fetchFailed": "Failed to fetch procedures/checklists"
    },
    "execute": {
      "button": "Execute",
      "title": "Execute Procedure",
      "step": "Step {{current}} of {{total}}",
      "previous": "Previous",
      "next": "Next",
      "finish": "Finish",
      "started": "Procedure execution started",
      "completed": "Procedure execution completed",
      "markDone": "Mark as done",
      "markNotDone": "Unmark as done"
    },
    "subItems": {
      "control": "Control",
      "requiredState": "Required state",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all"
    }
  },
  "categories": {
    "title": "Categories",
    "loading": "Loading categories...",
    "addNew": "Add Category",
    "deleted": "DELETED",
    "createTitle": "Create Category",
    "editTitle": "Edit Category",
    "empty": {
      "title": "No Categories",
      "descriptionCanCreate": "Create your first category to organize procedures.",
      "descriptionCannotCreate": "No categories have been created yet.",
      "noCategories": "No categories available"
    },
    "notFound": {
      "title": "Category Not Found",
      "description": "The requested category could not be found."
    },
    "delete": {
      "title": "Delete Category",
      "confirmMessage": "Are you sure you want to delete \"{{name}}\"? This action can be undone by an admin.",
      "successMessage": "Category deleted successfully",
      "errorMessage": "Failed to delete category"
    },
    "restore": {
      "button": "Restore",
      "successMessage": "Category restored successfully",
      "errorMessage": "Failed to restore category"
    },
    "create": {
      "successMessage": "Category created successfully"
    },
    "edit": {
      "successMessage": "Category updated successfully"
    },
    "form": {
      "name": "Name",
      "namePlaceholder": "Category name",
      "nameRequired": "Category name is required",
      "description": "Description",
      "descriptionPlaceholder": "Category description (optional)",
      "color": "Color",
      "order": "Order",
      "orderPlaceholder": "0",
      "orderInvalid": "Order must be a positive number",
      "orderHelp": "Categories with lower order numbers appear first",
      "preview": "Preview",
      "previewMeta": "0 procedures",
      "errors": {
        "saveFailed": "Failed to save category"
      }
    },
    "errors": {
      "fetchFailed": "Failed to fetch categories"
    }
  },
  "procedureForm": {
    "header": "Procedure/Checklist",
    "createTitle": "Create New Procedure/Checklist",
    "editTitle": "Edit Procedure/Checklist",
    "loading": "Loading checklist data...",
    "title": "Title",
    "titleRequired": "Title is required",
    "titlePlaceholder": "Enter procedure/checklist title",
    "description": "Description",
    "descriptionPlaceholder": "Enter description (optional)",
    "checklistItems": "Checklist Items",
    "addItem": "Add Item",
    "noItemsYet": "No items added yet",
    "clickAddItem": "Click \"Add Item\" to create your first checklist item",
    "item": "Item",
    "topic": "Topic",
    "topicRequired": "Topic is required",
    "topicPlaceholder": "Enter topic/title for this item",
    "content": "Content",
    "contentRequired": "Content is required",
    "contentPlaceholder": "Enter detailed content/instructions",
    "image": "Image",
    "addImage": "Add Image",
    "changeImage": "Change Image",
    "removeImage": "Remove",
    "link": "Link",
    "linkPlaceholder": "Enter external link (optional)",
    "categories": "Categories",
    "create": "Create",
    "update": "Update",
    "validationError": "Validation Error",
    "atLeastOneItem": "At least one checklist item is required",
    "allItemsMustHaveTopic": "All items must have a topic",
    "allItemsMustHaveContent": "All items must have content",
    "error": "Error",
    "failedToCreate": "Failed to create procedure/checklist",
    "failedToUpdate": "Failed to update procedure/checklist",
    "failedToLoad": "Failed to load checklist data",
    "permissionRequired": "Permission Required",
    "permissionDenied": "Only managers and administrators can create or edit procedures/checklists.",
    "failedToPickImage": "Failed to pick image",
    "success": "Success",
    "procedureCreated": "Procedure created successfully",
    "procedureUpdated": "Procedure updated successfully",
    "subItems": {
      "title": "Sub-items",
      "add": "Add sub-item",
      "addNested": "Add nested sub-item",
      "newSubItem": "New sub-item",
      "type": "Type",
      "typeSimple": "Description",
      "typeControl": "Control",
      "control": "Control",
      "controlPlaceholder": "Enter control description",
      "requiredState": "Required state",
      "requiredStatePlaceholder": "Enter required state",
      "confirmDelete": "Delete sub-item",
      "confirmDeleteMessage": "Are you sure you want to delete this sub-item?"
    },
    "confirmDelete": "Delete item",
    "confirmDeleteMessage": "Are you sure you want to delete this item?",
    "itemsRequired": "At least one item is required",
    "itemTopicRequired": "Item {{number}}: Topic is required",
    "itemContentRequired": "Item {{number}}: Content is required"
  },
  "contact": {
    "title": "Info & Contact",
    "about": "About",
    "aboutDescription": "This GOPR UAV Operations Manager application was developed by RedMed Software to help manage UAV operations efficiently and safely.",
    "contactInfo": "Contact Information",
    "company": "Company",
    "companyName": "RedMed Software",
    "generalContact": "General Contact",
    "technicalContact": "Technical Contact",
    "applicationInfo": "Application Info",
    "versionInfo": "GOPR UAV Ops Manager v{{version}} ({{commitHash}})\nDeveloped for GOPR (Volunteer Mountain Rescue Service)",
    "cannotOpenLink": "Cannot open this link",
    "failedToOpenLink": "Failed to open link"
  },
  "drawer": {
    "appTitle": "GOPR UAV Ops Manager",
    "editProfile": "Edit Profile",
    "signOut": "Sign Out"
  },
  "offline": {
    "noConnection": "No internet connection - viewing cached data",
    "viewingCachedData": "Viewing cached data from offline storage"
  },
  "sync": {
    "syncingData": "Synchronizing background data..."
  },
  "location": {
    "error": "Unable to get location. Please try again.",
    "errorTitle": "Location Error",
    "permissionDenied": "Location permission denied. Please enable location access in settings.",
    "timeout": "Location request timed out. Please try again.",
    "networkError": "Network error occurred while getting location.",
    "getCurrentLocation": "Get current location",
    "geocodingFallback": "GPS location found, but couldn't convert to readable address. Using coordinates instead.",
    "loading": "Getting location..."
  },
  "map": {
    "title": "Map Selection",
    "notImplemented": "Map selection feature coming soon!",
    "selectLocation": "Tap on the map to select a location",
    "noLocationSelected": "No location selected",
    "selectedCoordinates": "Selected:",
    "notAvailable": "Interactive map is not available on this platform",
    "useCoordinatesInput": "Please use the coordinates input field instead",
    "markerPlaced": "Marker placed"
  },
  "equipment": {
    "title": "Equipment",
    "list": "Equipment List",
    "item": "Equipment Item",
    "name": "Name",
    "namePlaceholder": "Enter equipment name",
    "quantity": "Quantity",
    "image": "Image",
    "addImage": "Add Image",
    "addItem": "Add Equipment Item",
    "removeItem": "Remove Equipment Item",
    "removeItemConfirm": "Are you sure you want to remove \"{{name}}\"? This will also delete any associated image.",
    "noEquipment": "No equipment items added yet",
    "addFirstItem": "Add your first equipment item using the button above",
    "noEquipmentInStorage": "No equipment items in this storage",
    "addFirstItemToStorage": "Add your first equipment item to this storage",
    "checklist": "Equipment Checklist",
    "checkEquipment": "Check Equipment",
    "items": "Items",
    "progress": "{{checked}} of {{total}} items checked",
    "allItemsChecked": "All equipment items have been checked!",
    "reset": "Reset",
    "checklistNote": "This checklist is for personal verification only and is not saved.",
    "reportMissing": "Report Missing Equipment",
    "reportMissingIntro": "Reporting missing equipment:",
    "reportMissingNone": "Nothing is missing.",
    "reportMissingNoDrone": "Cannot report missing equipment - no drone identifier.",
    "validation": {
      "nameRequired": "Equipment name is required",
      "nameRequiredInStorage": "Equipment name is required in storage \"{{storageName}}\"",
      "quantityRequired": "Quantity must be at least 1",
      "quantityRequiredInStorage": "Quantity must be at least 1 in storage \"{{storageName}}\""
    }
  },
  "equipmentStorage": {
    "storage": "Storage",
    "storages": "Equipment Storages",
    "name": "Storage Name",
    "namePlaceholder": "e.g., Bag 1, Case A, Tool Box",
    "addStorage": "Add Storage",
    "removeStorage": "Remove Storage",
    "removeStorageConfirm": "Are you sure you want to remove storage \"{{name}}\" and all its equipment items?",
    "noStorages": "No storage containers added yet",
    "addFirstStorage": "Add your first storage container using the button above",
    "validation": {
      "nameRequired": "Storage name is required"
    }
  },
  "comments": {
    "title": "Comments",
    "addComment": "Add Comment",
    "cancel": "Cancel",
    "noComments": "No comments yet",
    "beFirstToComment": "Be the first to add a comment about this drone",
    "addCommentForm": {
      "title": "Add Comment",
      "contentPlaceholder": "Enter your comment...",
      "attachImages": "Attach Images (Optional)",
      "visibilityTitle": "Visibility",
      "visibilityPublic": "Public",
      "visibilityPublicDesc": "Visible to all users",
      "visibilityHidden": "Hidden",
      "visibilityHiddenDesc": "Only visible to managers and admins",
      "submitButton": "Add Comment",
      "submittingButton": "Submitting...",
      "characterCount": "{{current}}/{{max}}"
    },
    "deleteConfirm": {
      "title": "Delete Comment",
      "message": "Are you sure you want to delete this comment? This action cannot be undone.",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "hideConfirm": {
      "title": "Hide comment",
      "message": "Are you sure you want to hide this comment?",
      "hide": "Hide",
      "cancel": "Cancel"
    },
    "messages": {
      "commentAdded": "Comment added successfully",
      "commentDeleted": "Comment deleted successfully",
      "addCommentError": "Failed to add comment. Please try again.",
      "deleteCommentError": "Failed to delete comment. Please try again.",
      "hideCommentError": "Failed to hide the comment.",
      "offlineError": "Comments require internet connection",
      "loadError": "Failed to load comments. Please try again.",
      "commentRemoved": "This comment has been removed.",
      "loadingComments": "Loading comments...",
      "loadMoreComments": "Load More Comments",
      "enterComment": "Please enter a comment"
    },
    "visibility": {
      "hidden": "Hidden",
      "public": "Public"
    },
    "actions": {
      "retry": "Retry"
    }
  },
  "filters": {
    "showFilters": "Show Filters",
    "hideFilters": "Hide Filters",
    "applyFilters": "Apply Filters",
    "clearFilters": "Clear Filters",
    "startDate": "Start Date:",
    "endDate": "End Date:",
    "category": "Category:",
    "drone": "Drone:",
    "activity": "Activity:",
    "entityType": "Entity Type:",
    "action": "Action:",
    "pilotEmail": "Pilot Email:",
    "userEmail": "User Email:",
    "all": "All",
    "entityTypes": {
      "drone": "Drone",
      "flight": "Flight",
      "procedureChecklist": "Procedure/Checklist",
      "user": "User",
      "task": "Task",
      "taskTemplate": "Task Template"
    },
    "actions": {
      "create": "Create",
      "edit": "Edit",
      "delete": "Delete",
      "restore": "Restore",
      "view": "View",
      "login": "Login",
      "assign": "Assign",
      "status_change": "Status Change",
      "self_assign": "Self Assign"
    }
  },
  "tasks": {
    "titleHeader": "Tasks",
    "taskDetails": "Task Details",
    "createTask": "Create Task",
    "editTask": "Edit Task",
    "createTemplate": "Create Template",
    "editTemplate": "Edit Template",
    "templates": "Templates",
    "noTasks": "No tasks found",
    "noTemplates": "No templates found",
    "unassigned": "Unassigned",
    "myOpen": "My Open",
    "myFinished": "My Finished",
    "allTasks": "All Tasks",
    "selfAssign": "Self Assign",
    "selfAssignTitle": "Self Assign Task",
    "selfAssignConfirmation": "Do you want to assign \"{{title}}\" to yourself?",
    "selfAssignSuccess": "Task assigned to you successfully",
    "selfAssignHelp": "When enabled, any user can assign this task to themselves",
    "deleteTitle": "Delete Task",
    "deleteConfirmation": "Are you sure you want to delete \"{{title}}\"?",
    "deleteSuccess": "Task deleted successfully",
    "deleteTemplateTitle": "Delete Template",
    "deleteTemplateConfirmation": "Are you sure you want to delete template \"{{title}}\"?",
    "deleteTemplateSuccess": "Template deleted successfully",
    "createSuccess": "Task created successfully",
    "updateSuccess": "Task updated successfully",
    "createTemplateSuccess": "Template created successfully",
    "updateTemplateSuccess": "Template updated successfully",
    "statusUpdateSuccess": "Task status updated successfully",
    "title": "Title",
    "titlePlaceholder": "Enter task title",
    "description": "Description",
    "descriptionPlaceholder": "Enter task description",
    "status": "Status",
    "statusNotStarted": "Not Started",
    "statusInProgress": "In Progress",
    "statusDone": "Done",
    "statusNotFinished": "Not Finished",
    "statusUpdate": "Status Update",
    "statusUpdateText": "Status Update Notes",
    "statusUpdatePlaceholder": "Enter notes about the status update...",
    "currentStatusUpdate": "Current Status Notes",
    "updateStatus": "Update Status",
    "selfSignEnabled": "Self-Sign Enabled",
    "assignTo": "Assign To",
    "assignedTo": "Assigned To",
    "createdBy": "Created By",
    "attachToDrone": "Attach to Drone",
    "attachToProcedure": "Attach to Procedure",
    "attachedToDrone": "Attached to Drone",
    "attachedToProcedure": "Attached to Procedure",
    "noDrone": "No Drone",
    "noProcedure": "No Procedure",
    "created": "Created",
    "started": "Started",
    "finished": "Finished",
    "details": "Details",
    "timeline": "Timeline",
    "useTemplate": "Use Template (Optional)",
    "selectTemplate": "Select a template...",
    "viewDetails": "View Details",
    "errors": {
      "fetchFailed": "Failed to fetch tasks",
      "fetchTemplatesFailed": "Failed to fetch templates",
      "notFound": "Task not found",
      "templateNotFound": "Template not found",
      "loadFailed": "Failed to load task",
      "loadTemplateFailed": "Failed to load template",
      "loadDataFailed": "Failed to load data",
      "createFailed": "Failed to create task",
      "updateFailed": "Failed to update task",
      "deleteFailed": "Failed to delete task",
      "createTemplateFailed": "Failed to create template",
      "updateTemplateFailed": "Failed to update template",
      "deleteTemplateFailed": "Failed to delete template",
      "statusUpdateFailed": "Failed to update task status",
      "selfAssignFailed": "Failed to self-assign task",
      "titleRequired": "Title is required",
      "descriptionRequired": "Description is required"
    }
  }
}